import React, { useState, useContext, createRef, useEffect } from "react";
import "../../styles/components/ToolBarLeftPanel.scss";
import { useTranslation } from "react-i18next";
import { isValidHttpUrl, checkURL } from "../../Uitls/Util";
import ImageLibrary from "./ImageLibrary";
import ValueContext from "../../ContextAPi/appContext";
import horizontalArrow from "../../images/horizontalArrow.svg";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import { toast } from "react-toastify";
import { uploadAnImageDragAndDrop, uploadAnImageLink } from "../../services/apis";

const ImageWindow = (props) => {
  const { linkImages, getLinkImages, imageCount, getLayerDetails } = props;
  const [URLValue, setURLValue] = useState("");
  const dropzoneRef = createRef();
  const [showToast, setShowToast] = useState(false);
  const [showToastForUplaod, setShowToastForUplaod] = useState(false);
  const [tab1Value, setTab1Value] = useState(0);
  const [showErrToast, setShowErrToast] = useState(false);
  const [showErrToastUpload, setShowErrToastUpload] = useState(false);
  const handleTab1 = (event, newValue) => {
    setTab1Value(newValue);
  };
  const { t } = useTranslation();
  const appData = useContext(ValueContext);

  const handleURL = (e) => {
    setURLValue(e.target.value);
  };
  const handleClearToast = () => {
    setShowToastForUplaod(false);
  };
  const handleClearLinkToast = () => {
    setShowToast(false);
  };
  const handleClearLinkErrToast = () => {
    setShowErrToast(false);
  };
  const handleClearUploadErrToast = () => {
    setShowErrToastUpload(false);
  };
  const URLUpdate = (e) => {
    if (isValidHttpUrl(URLValue)) {
      if (URLValue !== "" && checkURL(URLValue)) {
        var formData = {};
        formData.assetId = appData?.assetInfo?.assetId;
        formData.imageLink = URLValue;
        uploadAnImageLink(formData, (response, err, errorCode) => {
          if (err) {
            const errCoponent = ErrComponentToRender(errorCode);
            if (
              err.response?.data?.errorCode ===
              "ERR_EXCEED_MAX_UPLOAD_SIZE_500KB"
            ) {
              toast.error(
                <div className="notificationText">
                  {" "}
                  {t("imageWindowTabs.uploadErrmsg")}
                </div>
              );
            } else {
              toast.error(
                <div className="notificationText">{t("apiErrors.err500")}</div>
              );
            }
          } else {
            getLinkImages(appData?.assetInfo?.assetId);

            setURLValue("");
            setTab1Value(1);
            toast.success(
              <div className="notificationText">
                {t("imageWindowTabs.linkToastMsg")}
              </div>
            );
            setTimeout(() => {
              setShowToast(false);
            }, 3000);
          }
        });
      } else {
        toast.error(
          <div className="notificationText">
            {t("imageWindowTabs.linkToastErrMsg")}
          </div>
        );
        setTimeout(() => {
          setShowErrToast(false);
        }, 3000);
        setTab1Value(1);
      }
    }
    // }
  };
  const [showImageOpt, setShowImageOpt] = useState(false);
  const [showFileSize, setShowFileSize] = useState([]);
  const onDropImage = (accepted, rejected) => {
    if (Object.keys(rejected).length !== 0) {
      toast.success(
        <div className="notificationText">
          {t("imageWindowTabs.linkToastErrMsg")}
        </div>
      );
      setTimeout(() => {
        setShowErrToastUpload(false);
      }, 3000);
      setTab1Value(0);
    } else {
      const formData = new FormData();

      accepted.forEach((uploadFile) => {
        formData.append("imageFile", uploadFile);
      });

      uploadAnImageDragAndDrop(
        appData?.assetInfo?.assetId,
        formData,
        (response, err, errorCode) => {
          if (err) {
            const errCoponent = ErrComponentToRender(errorCode);
            if (
              err.response?.data?.errorCode ===
              "ERR_EXCEED_MAX_UPLOAD_SIZE_500KB"
            ) {
              toast.error(
                <div className="notificationText">
                  {" "}
                  {t("imageWindowTabs.uploadErrmsg")}
                </div>
              );
            } else {
              toast.error(
                <div className="notificationText">{t("apiErrors.err500")}</div>
              );
            }
          } else {
            getLinkImages(appData?.assetInfo?.assetId);
            setTab1Value(0);
            setShowFileSize(response.data);
            toast.success(
              <>
                <div className="notificationText">
                  {t("Image Uploaded successfully")}
                </div>
                <div className="imageOptimization">
                  <span>{t("Image optimised by 60%")}</span>
                  <div className="newFilesize">
                    New File size :
                    {response.data &&
                      response.data.map((item, index) => {
                        return (
                          <span key={index}>
                            {" "}
                            {item.fileSize} KB{" "}
                            {index === response.data.length - 1 ? "" : ","}
                          </span>
                        );
                      })}
                  </div>
                </div>
              </>
            );
            setTimeout(() => {
              setShowImageOpt(false);
            }, 3000);

            setTimeout(() => {
              setShowToastForUplaod(false);
            }, 3000);
          }
        }
      );
    }
  };

  return (
    <>
      <div className={showImageOpt ? "imageWindow2" : "imageWindow"}>
        <div className="imageTab">
          <div className="imageUrl d-flex">
            <img src={horizontalArrow} className="arrow-class" />
            <strong>Image</strong>
            <p style={{ margin: "0 0 0 2px" }}>{"(Add/Import/Upload)"}</p>
          </div>
          <ImageLibrary
            URLValue={URLValue}
            linkImages={linkImages}
            imageCount={imageCount}
            getLinkImages={getLinkImages}
            getLayerDetails={getLayerDetails}
            showToast={showToast}
            showToastForUplaod={showToastForUplaod}
            handleClearToast={handleClearToast}
            handleClearLinkToast={handleClearLinkToast}
            tab1Value={tab1Value}
            setTab1Value={setTab1Value}
            handleTab1={handleTab1}
            showErrToast={showErrToast}
            handleClearLinkErrToast={handleClearLinkErrToast}
            showErrToastUpload={showErrToastUpload}
            onDropImage={onDropImage}
            handleURL={handleURL}
            URLUpdate={URLUpdate}
          />{" "}
        </div>
      </div>
    </>
  );
};

export default ImageWindow;
